<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 3C3 2.448 3.448 2 4 2H6V18H4C3.448 18 3 17.552 3 17V3ZM15 2C16.105 2 17 2.895 17 4V16C17 17.105 16.105 18 15 18H7.5V2H15Z" fill="currentColor"/>
</svg>
